<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body{
  margin: 0;
  padding: 0;
  background-color: #fff;
}
.head{
    display: flex;
    height: 62px;
    background-color: #134170;
    width: 100%;
}
.head_icon{
    width: 118.6px;
    height: 26px;
    cursor: pointer;
    margin-top: 18px;
    margin-left: 40px;
}
.navbar{
    font-size: 0.875rem;
    color: #fff;
    margin-left: 9%;
}
.navbar .navbar_horizontal{
    display: flex;
}
.navbar .navbar_horizontal .navbar_horizontal_item{
    width: 96px;
    height: 62px;
    line-height: 62px;
    margin: 0 9px;
    text-align: center;
    border: none;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
    background-color: #1B5998;
}
.navbar .navbar_horizontal .navbar_horizontal_item1:hover{
    width: 96px;
    height: 62px;
    line-height: 62px;
    margin: 0 9px;
    text-align: center;
    border: none;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
    background-color: #1B5998;
}
.navbar .navbar_horizontal .navbar_horizontal_item1{
    width: 96px;
    height: 62px;
    line-height: 62px;
    margin: 0 9px;
    text-align: center;
    border: none;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
}
.navbar .navbar_vertical{
    cursor: pointer;
    margin-top: 16px;
    position: absolute;
    right: 30px;
}
.navbar .navbar_vertical .heng{
    width: 1.56rem;
    height: 2px;
    background-color: #fff;
    margin: 6px 0;
}
.el-drawer.ttb{
  width: 95%;
  margin: 10px;
  border-radius: 4px;
}
.el-drawer__header{
  margin-bottom: 0;
}
.search{
    width: 272px;
    height: 34px;
    margin-left: 2%;
    border-bottom: 1px solid #FFFFFF;
    margin-top: 18px;
    display: flex;
    align-items: center;
}
.search_button{
    cursor: pointer;
    margin-right: 21px;
}
.search .el-input__inner{
  border: none;
  height: 26px;
  background-color: #134170;
  color: #fff;
}
.search1{
  width: 95%;
  height: 44px;
  margin-left: 2%;
  border: 1px solid #134170;
  margin-top: 10px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.search1 .el-input__inner{
  border: none;
}
.search_button1{
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.draw_navbar{
  margin-top: 10px;
  font-size: 1rem;
}
.draw_navbar_item{
  color: #000;
  height: 54px;
  line-height: 54px;
  padding-left: 20px;
}
.draw_navbar_item:hover{
  color: #88D2FF;
  background-color: #ECF5FF;
  height: 54px;
  line-height: 54px;
  padding-left: 20px;
}
.draw_navbar_item1{
  color: #88D2FF;
  height: 54px;
  line-height: 54px;
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue